"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _dayjs = _interopRequireDefault(require("dayjs"));

var _relativeTime = _interopRequireDefault(require("dayjs/plugin/relativeTime"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

_dayjs["default"].extend(_relativeTime["default"]);

var TimeAgo = function TimeAgo(_ref) {
  var date = _ref.date,
      title = _ref.title;
  return /*#__PURE__*/_react["default"].createElement("span", {
    title: title
  }, (0, _dayjs["default"])().to((0, _dayjs["default"])(new Date(date))));
};

var _default = TimeAgo;
exports["default"] = _default;